.searchTabs {
  display: flex;
  border-bottom: 1px solid rgb(255, 255, 255, 0.2);

  .searchTab {
    flex-grow: 1;
  }
}